import { captureInstallPrompt } from './installPrompt';
import { seedStandaloneHistory } from './standalone';

let prepared = false;

/** Captures the install event and seeds standalone navigation before BrowserRouter reads history. */
export function preparePwaNavigation(): void {
  if (prepared) return;
  prepared = true;
  captureInstallPrompt();
  seedStandaloneHistory();
}
